module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.couldRender) ? _c('div', {
    style: ({
      backgroundImage: 'url(' + _vm.bgImg + ')'
    }),
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "turnplate",
      "data-spider": "PRLYujHT92"
    }
  }, [_c('div', {
    staticClass: "outer-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-award",
    attrs: {
      "data-spider": "dMyAward",
      "data-spider-action-name": "dMyAward",
      "data-spider-action-args": "{}",
      "spm-auto": "我的奖品",
      "spm-click": "click"
    },
    on: {
      "click": _vm.goAwardsPage
    }
  }), _vm._v(" "), _c('div', {
    class: ['real-deg', _vm.outerPanelClass]
  }, [_c('div', {
    class: ['inner-1', _vm.panelRotateClass],
    style: (_vm.panelStyle)
  })]), _vm._v(" "), _c('div', {
    class: ['inner-2', _vm.pointerClass],
    attrs: {
      "data-spider": "dPlay",
      "data-spider-action-name": "dPlay",
      "data-spider-action-args": "{}",
      "spm-auto": "抽奖",
      "spm-click": "click"
    },
    on: {
      "click": _vm.play
    }
  }, [_c('i', {
    staticClass: "pointer-triangle"
  }), _vm._v(" "), _c('div', {
    staticClass: "pointer-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "lottery-word-1"
  }, [_vm._v("抽奖")])]), _vm._v(" "), (_vm.activityStatus === 0) ? _c('div', {
    staticClass: "chance-left"
  }, [_vm._v("还有" + _vm._s(_vm.chanceLeft) + "次机会")]) : (_vm.activityStatus >= 1 && _vm.activityStatus <= 3) ? _c('div', {
    staticClass: "chance-left"
  }, [_vm._v(_vm._s(_vm.activityStatusStr) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._v(" "), (typeof _vm.panelInfo.data.features.links !== 'undefined' && _vm.panelInfo.data.features.links.length > 0) ? _c('ul', {
    staticClass: "links"
  }, _vm._l((_vm.panelInfo.data.features.links), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": item.url,
        "data-spider": "",
        "spm-auto": item.text
      }
    }, [_vm._v(_vm._s(item.text))])])
  })) : _vm._e(), _vm._v(" "), _vm._v(" ")])]) : _vm._e(), _vm._v(" "), _c('vm-confirm', {
    attrs: {
      "show": _vm.confirmFlag,
      "img": _vm.confirmImg
    },
    on: {
      "close": _vm.closeConfirm
    }
  }), _vm._v(" "), _c('vm-error', {
    attrs: {
      "config": _vm.errorConfig
    }
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-loader/lib/template-compiler.js?id=data-v-64dd0058!../~/vue-loader/lib/selector.js?type=template&index=0!./components/vue/turnplate.vue
 ** module id = 130
 ** module chunks = 1
 **/